export { correctedHashModeReplaceUrl } from './hash-url';
